import { Typography } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const BuiltInValue = styled(Typography.Body3)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral[30]};
`;
